import Klogo from "../components/KLogo"
import ScrollArrow from "../components/ScrollArrow"
import SponsorMarquee from "../components/SponsorMarquee"
import EventsCarousel from "../components/EventsCarousel"
import AboutPreview from "../components/AboutPreview"
import { useRef } from 'react'
import ig from "../assets/ig.svg"
import fb from "../assets/fb.svg"
import tiktok from "../assets/tiktok.svg"
import yt from "../assets/youtube.svg"
import disc from "../assets/discord.svg"
import { useNavigate } from "react-router"
import spotify from "../assets/spotify.svg"
import boy from "../assets/boy.png"
import girl from "../assets/girl.png"
import arcLogo from "../assets/arc_logo.png"
import unswLogo from "../assets/unsw_logo.png"

export default function Home() {
    const eventsRef = useRef()
    const navigate = useNavigate();

    return(
    <>
      <section className="w-full min-h-screen overflow-x-hidden">

        {/* HERO */}
        <section className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-x-hidden bg-pastel-hero px-6 md:pt-[76px]">
          <div className="absolute inset-0 bg-white/10 pointer-events-none"></div>

          {/* AFFILIATION LOGOS */}
          <div className="absolute bottom-8 right-8 z-10 flex items-center gap-6 opacity-90">
            <img src={arcLogo} alt="Arc UNSW" className="h-10 md:h-14 object-contain drop-shadow-md" />
            <img src={unswLogo} alt="UNSW Sydney" className="h-10 md:h-14 object-contain drop-shadow-md" />
          </div>

          <div className="relative z-10 flex flex-col items-center text-center pt-10 md:pt-6">
            <Klogo className="w-[520px] sm:w-[420px] md:w-[520px]" />

            <h1 className="mt-4 text-2xl md:text-4xl font-extrabold text-ink tracking-tight max-w-3xl">
              WHERE KPOP FANS BECOME FAMILY.
            </h1>
            <p className="mt-4 max-w-xl text-ink/70 text-base md:text-lg">
              UNSW's home for all things K-pop, dance covers, socials, comebacks,
              and a community that gets just as hyped as you do.
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center gap-4">
              <div className="group relative">
                <button
                  onClick={() => navigate("/join")}
                  className="px-6 py-2.5 rounded-full text-sm font-semibold text-white bg-gradient-to-r from-pastel-blue-dark via-pastel-pink-dark to-pastel-purple-dark shadow-md hover:shadow-lg hover:scale-105 transition-all"
                >
                  BECOME A MEMBER
                </button>
                <img src={boy} alt="" className="absolute top-0 right-0 -translate-y-[60%] w-[60px] h-[60px] object-contain opacity-0 group-hover:opacity-100 transition-opacity duration-150 pointer-events-none z-10" />
              </div>
              <div className="group relative">
                <button
                  onClick={() => navigate("/events")}
                  className="px-6 py-2.5 rounded-full text-sm font-semibold text-ink bg-white/80 border border-pastel-purple-dark/30 shadow-sm hover:bg-white hover:shadow-md transition-all"
                >
                  OUR EVENTS
                </button>
                <img src={girl} alt="" className="absolute top-0 right-0 -translate-y-[60%] -translate-x-4 w-[60px] h-[60px] object-contain opacity-0 group-hover:opacity-100 transition-opacity duration-150 pointer-events-none z-10" />
              </div>
            </div>
          </div>

          <div className="relative z-10 mt-10">
            <ScrollArrow scrollToRef={eventsRef} />
          </div>
        </section>

        {/* ABOUT */}
        <AboutPreview />

        {/* SPONSORS / AFFILIATIONS */}
        <section className="w-full bg-white py-14 px-6">
          <div className="text-center mb-2">
            <h2 className="text-sm font-bold tracking-[0.2em] text-pastel-purple-dark">OUR SPONSORS</h2>
            <h3 className="text-2xl md:text-3xl font-extrabold text-ink mt-2">Supported by our favourite spots.</h3>
          </div>
          <SponsorMarquee />
        </section>

        {/* UPCOMING EVENTS */}
        <section
            ref={eventsRef}
            className="w-full bg-pastel-soft py-20 px-6 md:px-16"
        >
          <div className="max-w-6xl mx-auto">
            <div className="mb-10 flex flex-wrap items-end justify-between gap-4">
              <div>
                <h2 className="text-sm font-bold tracking-[0.2em] text-pastel-blue-dark">WHAT'S ON</h2>
                <h3 className="text-3xl md:text-4xl font-extrabold text-ink mt-2">Explore Our Events.</h3>
                <p className="mt-4 text-ink/70 max-w-xl">
                  A taste of what's coming up. See the full calendar for everything KPOP SOCIETY has planned.
                </p>
              </div>
              <button
                onClick={() => navigate("/events")}
                className="shrink-0 px-6 py-2.5 rounded-full text-sm font-semibold text-white bg-gradient-to-r from-pastel-blue-dark via-pastel-pink-dark to-pastel-purple-dark shadow-md hover:shadow-lg hover:scale-105 transition-all"
              >
                View All Events
              </button>
            </div>

            <EventsCarousel embedded showHeading={false} />
          </div>
        </section>

        {/* SOCIALS / CLOSING BANNER */}
        <section className="w-full bg-white py-16 px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-extrabold text-ink">Want to stay up to date?</h2>
          <p className="mt-2 text-ink/70">Follow along for comebacks, socials, and everything KPOP SOCIETY.</p>
          <div className="grid gap-6 pt-8 grid-cols-3 md:grid-cols-6 max-w-xl mx-auto">
            <a href="https://www.instagram.com/unswkpop/" target="_blank" rel="noopener noreferrer">
              <img src={ig} alt="Instagram" className="w-12 h-12 mx-auto transition-transform duration-300 ease-in-out hover:scale-110 hover:opacity-80" />
            </a>
            <a href="https://www.facebook.com/unswkpop/" target="_blank" rel="noopener noreferrer">
              <img src={fb} alt="Facebook" className="w-12 h-12 mx-auto transition-transform duration-300 ease-in-out hover:scale-110 hover:opacity-80" />
            </a>
            <a href="https://www.tiktok.com/@unswkpop" target="_blank" rel="noopener noreferrer">
              <img src={tiktok} alt="TikTok" className="w-12 h-12 mx-auto transition-transform duration-300 ease-in-out hover:scale-110 hover:opacity-80" />
            </a>
            <a href="https://www.youtube.com/c/unswkpopsociety" target="_blank" rel="noopener noreferrer">
              <img src={yt} alt="Youtube" className="w-12 h-12 mx-auto transition-transform duration-300 ease-in-out hover:scale-110 hover:opacity-80" />
            </a>
            <a href="https://discord.com/invite/kGz5kxpzCF" target="_blank" rel="noopener noreferrer">
              <img src={disc} alt="Discord" className="w-12 h-12 mx-auto transition-transform duration-300 ease-in-out hover:scale-110 hover:opacity-80" />
            </a>
            <a href="https://open.spotify.com/user/316ivsboitfa3jbjvonn2cl2icwm?si=a1dbfce0714e4d0f" target="_blank" rel="noopener noreferrer">
              <img src={spotify} alt="Spotify" className="w-11 h-11 mx-auto transition-transform duration-300 ease-in-out hover:scale-110 hover:opacity-80" />
            </a>
          </div>
        </section>

      </section>
    </>
    )
}